import { render, staticRenderFns } from "./communitystudent.vue?vue&type=template&id=723c09ae&"
import script from "./communitystudent.vue?vue&type=script&lang=js&"
export * from "./communitystudent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports